<div class="rule-config-page">
  <div class="page-title">Supporting Document Rule Configuration</div>

  <div class="rule-card">
    <form [formGroup]="ruleForm">
      <div class="rule-grid">
        <div class="form-group">
          <label>Wizard Page</label>
          <select class="form-control" formControlName="stepperId" (change)="onStepperPageChange()">
            <option value="">Select Wizard Page</option>
            <option *ngFor="let wizardPage of wizardPageOptions" [value]="wizardPage.stepperId">{{ wizardPage.wizardPageName }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Tab Name</label>
          <select class="form-control" formControlName="tabId" (change)="onTabChange()">
            <option value="">Select Tab</option>
            <option *ngFor="let tab of tabOptions" [value]="tab.pageId">{{ tab.pageName }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Section / Panel</label>
          <select class="form-control" formControlName="sectionKey" (change)="onSectionChange()">
            <option value="">Select Panel</option>
            <option *ngFor="let panel of panelOptions" [value]="panel.sectionNameLabel">{{ panel.sectionNameLabel }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Match Type</label>
          <select class="form-control" formControlName="logicalOperator" (change)="syncExpressions()">
            <option value="AND">Match All Conditions</option>
            <option value="OR">Match Any Condition</option>
          </select>
        </div>

        <div class="form-group">
          <label>Show Additional Category</label>
          <select class="form-control" formControlName="showAdditionalCategory" (change)="onShowAdditionalCategoryChange()">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Yes</option>
          </select>
        </div>

        <div class="form-group">
          <label>Category</label>
          <select class="form-control" formControlName="category" (change)="onCategoryChange()">
            <option value="">Select Category</option>
            <option *ngFor="let category of categoryOptions" [value]="category.value">{{ category.label }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Type</label>
          <select class="form-control" formControlName="documentType">
            <option value="">Select Type</option>
            <option *ngFor="let type of documentTypeOptions" [value]="type.value">{{ type.label }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Sort Order</label>
          <input type="number" class="form-control" formControlName="sortOrder" />
        </div>

        <div class="form-group d-flex align-items-center">
          <div class="form-check mt-4 pt-2">
            <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive" />
            <label class="form-check-label" for="isActive">Active</label>
          </div>
        </div>

        <div class="form-group d-flex align-items-center">
          <div class="form-check mt-4 pt-2">
            <input class="form-check-input" type="checkbox" id="showAlwaysDefault" formControlName="showAlwaysDefault" />
            <label class="form-check-label" for="showAlwaysDefault">Show Always as Default (Optional Upload)</label>
          </div>
        </div>

        <ng-container *ngIf="ruleForm.get('showAlwaysDefault')?.value">
          <div class="form-group">
            <label>Role ID (for Show Always condition)</label>
            <input type="text" class="form-control" formControlName="showAlwaysRoleId" placeholder="e.g. 405" />
            <small class="form-text text-muted">Enter the role ID this condition applies to. Leave blank to apply to all roles.</small>
          </div>

          <div class="form-group">
            <label>Show for this Role?</label>
            <select class="form-control" formControlName="showAlwaysRoleMatch">
              <option [ngValue]="false">false — Show for all EXCEPT this role</option>
              <option [ngValue]="true">true — Show ONLY for this role</option>
            </select>
            <small class="form-text text-muted">e.g. Role 405 + false = only non-405 users see this grid as always-default.</small>
          </div>
        </ng-container>

        <div class="form-group d-flex align-items-center">
          <div class="form-check mt-4 pt-2">
            <input class="form-check-input" type="checkbox" id="isNotRequired" formControlName="isNotRequired" />
            <label class="form-check-label" for="isNotRequired">Not Required (Document optional, no validation blocking)</label>
          </div>
        </div>

        <div class="form-group d-flex align-items-center">
          <div class="form-check mt-4 pt-2">
            <input class="form-check-input" type="checkbox" id="enableDynamicTypeFromField" formControlName="enableDynamicTypeFromField" />
            <label class="form-check-label" for="enableDynamicTypeFromField">Enable Dynamic Type from Form Field</label>
          </div>
        </div>

        <ng-container *ngIf="ruleForm.get('enableDynamicTypeFromField')?.value">
          <div class="form-group">
            <label>Dynamic Type Source Field</label>
            <select class="form-control" formControlName="dynamicTypeSourceField">
              <option value="">None (use static type)</option>
              <option *ngFor="let field of fieldOptions" [value]="field.fieldKey">{{ field.fieldLabel }}</option>
            </select>
            <small class="form-text text-muted">When set, the document type will be populated from this form field's value at runtime.</small>
          </div>

          <div class="form-group">
            <label>Dynamic Type Lookup Category</label>
            <input type="text" class="form-control" formControlName="dynamicTypeLookupCategory" placeholder="e.g. STATE, DISTRICT" />
            <small class="form-text text-muted">If the source field is a dropdown, enter the lookup request type to resolve the key to a display value.</small>
          </div>
        </ng-container>
      </div>

      <div class="conditions-card mt-3">
        <div class="conditions-header">
          <div>
            <div class="conditions-title">Rule Conditions</div>
            <div class="conditions-subtitle">Add one or more field conditions and combine them with the selected match type.</div>
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="addCondition()">Add Condition</button>
        </div>

        <div formArrayName="conditions" class="conditions-list">
          <div class="condition-row" *ngFor="let condition of conditionRows.controls; let i = index" [formGroupName]="i">
            <div class="form-group">
              <label>Field</label>
              <select class="form-control" formControlName="fieldKey" (change)="syncExpressions()">
                <option value="">Select Field</option>
                <option *ngFor="let field of fieldOptions" [value]="field.fieldKey">{{ field.fieldLabel }}</option>
              </select>
            </div>

            <div class="form-group">
              <label>Operator</label>
              <select class="form-control" formControlName="operator" (change)="syncExpressions()">
                <option *ngFor="let operator of operatorOptions" [value]="operator.value">{{ operator.label }}</option>
              </select>
            </div>

            <div class="form-group">
              <label>Field Value</label>
              <input type="text" class="form-control" formControlName="fieldValue" (input)="syncExpressions()" />
            </div>

            <div class="condition-action">
              <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeCondition(i)">Remove</button>
            </div>
          </div>
        </div>
      </div>

      <div class="rule-grid mt-3">
        <div class="form-group">
          <label>Condition JSON</label>
          <textarea class="form-control" rows="8" formControlName="conditionJson"></textarea>
        </div>
      </div>

      <div class="rule-grid mt-3">
        <div>
          <label class="mb-2">Generated Condition JSON</label>
          <div class="expression-box">{{ previewConditionJson || 'Add one or more conditions to generate condition JSON.' }}</div>
        </div>
      </div>

      <div class="rule-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="resetForm()">Clear</button>
        <button type="button" class="btn btn-primary" (click)="saveRule()">{{ editingRuleId ? 'Update Rule' : 'Save Rule' }}</button>
      </div>
    </form>
  </div>

  <div class="rule-card">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="fw-bold">Existing Rules</div>
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="loadRules()">Refresh</button>
    </div>

    <div class="table-responsive">
      <table class="rules-table">
        <thead>
          <tr>
            <th>Page</th>
            <th>Tab</th>
            <th>Panel</th>
            <th>Category</th>
            <th>Type</th>
            <th>Dynamic Source Field</th>
            <th>Lookup Category</th>
            <th>Additional Category</th>
            <th>Condition JSON</th>
            <th>Status</th>
            <th>Show Always (Role)</th>
            <th>Not Required</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rule of rules">
            <td>{{ rule.page_name }}</td>
            <td>{{ rule.tab_name }}</td>
            <td>{{ rule.panel_key }}</td>
            <td>{{ getCategoryLabel(rule.cd_document_category) }}</td>
            <td>{{ getTypeLabel(rule.cd_document_type || '', rule.cd_document_category) }}</td>
            <td>{{ rule.dynamic_type_source_field || '-' }}</td>
            <td>{{ rule.dynamic_type_lookup_category || '-' }}</td>
            <td>{{ isRuleAdditionalCategory(rule) ? 'Yes' : 'No' }}</td>
            <td>{{ rule.condition_json | json }}</td>
            <td>{{ rule.is_active ? 'Active' : 'Inactive' }}</td>
            <td>{{ rule.show_always_default ? ('Yes' + (rule.condition_json?.show_always_role_id ? ' (Role ' + rule.condition_json?.show_always_role_id + ': ' + (rule.condition_json?.show_always_role_match ? 'only' : 'exclude') + ')' : '')) : 'No' }}</td>
            <td>{{ rule.condition_json?.is_not_required ? 'Yes' : 'No' }}</td>
            <td>
              <div class="table-actions">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="editRule(rule)">Edit</button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteRule(rule)">Delete</button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!rules.length">
            <td colspan="13" class="text-center text-muted">No rules available.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
